import { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";

const adres = "https://api.pth-hokej.pl";

const AdminWrapper = styled.div`
  max-width: 800px;
  margin: 30px auto;
  padding: 20px;
  border-radius: 12px;
  background: #f9f9f9;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.08);
  font-family: Arial, sans-serif;
`;

const Title = styled.h2`
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 20px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
`;

const Form = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  input {
    flex: 1;
    min-width: 150px;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #66aaff;
      box-shadow: 0 0 3px rgba(102,170,255,0.5);
    }
  }
`;

const AddButton = styled.button`
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s ease-in-out;

  &:hover {
    background: #357abd;
  }
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px 15px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  b {
    color: #333;
  }
`;

const DeleteButton = styled.button`
  background: #ff5a5a;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s ease-in-out;

  &:hover {
    background: #e04a4a;
  }
`;

export const AdminKafelki = ({ type = "contacts" }) => {
  const [kafelki, setKafelki] = useState([]);
  const [form, setForm] = useState({ icon: "", nazwa: "", value: "", link: "" });

  useEffect(() => {
    fetch(`${adres}/api/${type}`)
      .then(res => res.json())
      .then(data => setKafelki(data));
  }, [type]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAdd = async () => {
    const res = await fetch(`${adres}/api/${type}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });
    const newKafelek = await res.json();
    setKafelki([...kafelki, newKafelek]);
    setForm({ icon: "", nazwa: "", value: "", link: "" });
  };

  const handleDelete = async (id) => {
    await fetch(`${adres}/api/${type}/${id}`, { method: "DELETE" });
    setKafelki(kafelki.filter(k => k._id !== id));
  };

  return (
    <AdminWrapper>
      <Title>Panel admina: {type == "contacts" ? " kafelki 'kontakt'":" kafelki 'social media'"}</Title>
      
      <Form>
        <input name="icon" placeholder="Ikona" value={form.icon} onChange={handleChange} />
        <input name="nazwa" placeholder="Nazwa" value={form.nazwa} onChange={handleChange} />
        <input name="value" placeholder="Wartość" value={form.value} onChange={handleChange} />
        <input name="link" placeholder="Link" value={form.link} onChange={handleChange} />
        <AddButton onClick={handleAdd}>Dodaj</AddButton>
      </Form>

      <List>
        {kafelki.map(k => (
          <ListItem key={k._id}>
            <span>
              <b>{k.nazwa}</b>: {k.value}
            </span>
            <DeleteButton onClick={() => handleDelete(k._id)}>Usuń</DeleteButton>
          </ListItem>
        ))}
      </List>
    </AdminWrapper>
  );
};
